// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import './ICDCodes.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton, SecondaryButton } from 'ui_kit_qmd'
import classNames from 'classnames'
import caret from '../../images/common/chevronUp.png'
import { styles, text } from './Constants'
import { Code } from './components/code/Code'
import ICDSearch from '../icd-search/ICDSearch'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'

export const ICDCodes = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isOpen,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  description,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  toggleICD10Codes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSearch,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  icdSearchResults,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSelectICDCode,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  addedICDCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  updateICDCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitICDCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isDetailsMode,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isReadOnly,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  localError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  deleteCode,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  deleteCodeFromList,
  isEditing = false,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  hasEnded,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  editIcdCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isCancelledStatus,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isIcdCodesChanged,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  saving,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setLocalPastVisitPageError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setLocalICDCodesError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitStatus,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isForceUpdateIcdCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsForceUpdateIcdCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isUpcomingVisit,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isInPersonVisit,
}) => {
  const [icdSearchOpened, setICDSearchOpened] = useState(false)

  useEffect(
    () => () => {
      if (updateICDCodes) updateICDCodes(null, false, false, true)
    },
    [],
  )

  const onCancelClick = () => editIcdCodes(false)

  const onSaveClick = () => {
    if (isIcdCodesChanged || isForceUpdateIcdCodes) {
      if (!visitICDCodes.length && visitStatus === 'completed' && !isInPersonVisit) {
        setLocalPastVisitPageError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
        setLocalICDCodesError(getUserFriendlyErrorMessage(errorCodes.ICD_CODE_MISSING))
      } else {
        if (isForceUpdateIcdCodes) {
          setIsForceUpdateIcdCodes(false)
        }
        updateICDCodes(null, null, true)
      }
    } else {
      editIcdCodes(false)
    }
  }

  return (
    <div
      className={`icd10-code-container ${
        isDetailsMode ?
          isReadOnly || (hasEnded && !isEditing) ?
            'icd10-code-detail-container icd10-code-detail-read-only-height'
          : 'icd10-code-detail-container'
        : ''
      }`}
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      style={!icdSearchOpened ? styles.SEARCH_RESULTS_HIDDEN : null}>
      <div
        className={classNames('icd10-code-header', [
          {
            'icd10-header-with-empty-table': isUpcomingVisit || !visitICDCodes?.length,
          },
        ])}>
        <div>
          <label htmlFor='null' className='icd10-code-title'>
            {`${isEditing ? `${text.EDIT} ` : ''}${text.TITLE}`}
          </label>
          {description ?
            <div className='icd10-code-description'>{description}</div>
          : null}
        </div>

        {!isDetailsMode && (
          <img
            src={caret}
            alt='caret'
            className={`caret-icon ${!isOpen ? 'icd10-code-closed' : ''}`}
            onClick={toggleICD10Codes}
            role='presentation'
          />
        )}
        {isDetailsMode && !isReadOnly && hasEnded && !isEditing && !isCancelledStatus && !isUpcomingVisit ?
          <SecondaryButton
            btnText={text.EDIT}
            containerStyle={visitICDCodes?.length ? styles.EDIT_BUTTON_STYLE : styles.EDIT_BUTTON_EMPTY_SECTION_STYLE}
            onPress={() => {
              editIcdCodes(true)
            }}
          />
        : null}
      </div>
      {isOpen || isDetailsMode ?
        <div className='icd10-code-inner-container'>
          {!isReadOnly && (isEditing || (!isEditing && !hasEnded && !isReadOnly)) ?
            <div className='icd10-code-search-container'>
              <ICDSearch
                onInputChange={onSearch}
                containerStyle={{ width: '100%' }}
                placeholder={text.PLACEHOLDER}
                searchResults={icdSearchResults}
                addedICDCodes={addedICDCodes}
                willBlurList={() => {
                  updateICDCodes(null, !isEditing)
                }}
                onSearchResultSelect={onSelectICDCode}
                isDetailsMode={isDetailsMode}
                deleteCode={deleteCode}
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                onSearchOpened={(value) => {
                  setICDSearchOpened(value)
                }}
                saving={saving}
              />
            </div>
          : null}
          {visitICDCodes?.length ?
            <div
              className={`icd10-code-list-container ${
                isReadOnly || (hasEnded && !isEditing) ? 'icd10-code-list-read-only-container' : ''
              }`}
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              style={isReadOnly || (hasEnded && !isEditing) ? styles.READ_ONLY_LIST_HEIGHT_STYLE : null}>
              {/*
               // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
              {visitICDCodes?.map((item, index) => (
                <Code
                  code={item.Code}
                  description={item.Description}
                  isReadOnly={isReadOnly || (hasEnded && !isEditing)}
                  id={item.IcdCodeId}
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  index={index}
                  isDetailsMode={isDetailsMode}
                  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                  deleteCode={(value) => {
                    deleteCodeFromList(value, !isEditing)
                  }}
                />
              ))}
            </div>
          : <div className='icd10-code-empty-parent'>
              <div
                className={`icd10-code-empty-container ${localError ? 'icd10-code-error' : ''}`}
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                style={isDetailsMode ? styles.DETAILS_NO_CODES_HEIGHT : null}>
                <label className='icd10-code-empty-label' htmlFor='null'>
                  {text.NO_CODES}
                </label>
              </div>
              {localError ?
                <label
                  className='icd10-code-local-error-text'
                  htmlFor='null'
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  style={isDetailsMode ? styles.DETAILS_TOP_ERROR_STYLE : null}>
                  {localError}
                </label>
              : null}
            </div>
          }
        </div>
      : null}
      {isDetailsMode && !isReadOnly && hasEnded && isEditing ?
        <div className='icd10-code-edit-btn-container'>
          <SecondaryButton btnText={text.CANCEL} containerStyle={styles.CANCEL_BUTTON_STYLE} onPress={onCancelClick} />
          <PrimaryButton btnText={text.SAVE} containerStyle={styles.SAVE_BUTTON_STYLE} onPress={onSaveClick} />
        </div>
      : null}
      <div
        className={`icd10-code-line ${
          isDetailsMode ?
            isEditing ? 'icd10-code-line-edit'
            : 'icd10-code-line-detail'
          : ''
        }`}
      />
    </div>
  )
}
